import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Factory, Globe } from "lucide-react";
import { BRAND } from "../mock/mock";
import logo from "../assets/meilleur-logo.png";

const Footer = () => {
  return (
    <footer className="bg-[var(--noir-2)] border-t border-[var(--line)] pt-20 pb-10">
      <div className="max-w-[1360px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-6">
              <img src={logo} alt="Meilleur Oudh & Aromas logo" className="w-14 h-14 rounded-full object-cover ring-1 ring-[var(--line)] bg-white shrink-0" />
              <div>
                <span className="font-marcellus text-2xl tracking-[0.18em] text-[var(--ivory)] block leading-none">MEILLEUR</span>
                <p className="eyebrow mt-1">Oudh &amp; Aromas</p>
              </div>
            </div>
            <p className="text-[var(--ivory-muted)] text-sm leading-relaxed max-w-xs font-body">
              From tree to trade — agarwood chips, oud oil and value-added aromatics, grown and manufactured on our own
              plantations in Assam, Tripura and Nagaland.
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="eyebrow mb-6">Collections</h4>
            <ul className="space-y-3 text-sm text-[var(--ivory-muted)] font-body">
              {[
                ["Oud Chips", "/oud-chips"],
                ["Oud Oil", "/oud-oil"],
                ["Bakhoor", "/bakhoor"],
                ["Oud Craft", "/other-products"],
              ].map(([l, to]) => (
                <li key={to}>
                  <Link to={to} className="hover:text-[var(--gold-light)] transition-colors">{l}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="eyebrow mb-6">The House</h4>
            <ul className="space-y-3 text-sm text-[var(--ivory-muted)] font-body">
              {[
                ["About", "/about"],
                ["Four Brands", "/house"],
                ["Gallery", "/gallery"],
                ["Recognitions", "/recognitions"],
                ["Contact", "/contact"],
              ].map(([l, to]) => (
                <li key={to}>
                  <Link to={to} className="hover:text-[var(--gold-light)] transition-colors">{l}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="eyebrow mb-6">Reach Us</h4>
            <ul className="space-y-4 text-sm text-[var(--ivory-muted)] font-body">
              <li className="flex items-start gap-3"><Phone size={16} className="text-[var(--gold)] mt-0.5 shrink-0" /><span>{BRAND.phone} / {BRAND.phoneAlt}</span></li>
              <li className="flex items-start gap-3"><Mail size={16} className="text-[var(--gold)] mt-0.5 shrink-0" /><span>{BRAND.email}</span></li>
              <li className="flex items-start gap-3"><MapPin size={16} className="text-[var(--gold)] mt-0.5 shrink-0" /><span>{BRAND.address}</span></li>
              <li className="flex items-start gap-3"><Factory size={16} className="text-[var(--gold)] mt-0.5 shrink-0" /><span>{BRAND.factory}</span></li>
              <li className="flex items-start gap-3"><Globe size={16} className="text-[var(--gold)] mt-0.5 shrink-0" /><span>{BRAND.website}</span></li>
            </ul>
          </div>
        </div>

        <div className="hairline opacity-40" />
        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs tracking-[0.16em] uppercase text-[var(--ivory-muted)]">
            © {new Date().getFullYear()} The House of Meilleur — Empowering Community
          </p>
          <p className="text-xs tracking-[0.16em] uppercase text-[var(--ivory-muted)]">
            Golaghat, Assam · Faridabad NCR · Indore
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
